import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import React from "react";

import { alert } from "../common/Alert";
import AttachmentSelection from "../common/inputs/AttachmentSelection";
import { DSButton } from "../design-system/molecules";

const DELETE_HEADER_IMAGE = gql`
  mutation deleteHeaderImage {
    deleteHeaderImage {
      ok
    }
  }
`;

export default function HeaderImageUpload({
  data,
  loading,
  refetch,
  isEditing,
  setIsEditing,
  control,
}) {
  const [deleteHeaderImage] = useMutation(DELETE_HEADER_IMAGE);

  function renderLogo() {
    return (
      <div className="flex flex-col items-center space-y-xs">
        <div className="flex flex-row items-center justify-center relative">
          <div>
            <h4
              className="text-xs text-center"
              data-testid={
                data?.user?.account?.logoFileLink
                  ? "current-header-text"
                  : "default-header-text"
              }
            >
              {data?.user?.account?.logoFileLink
                ? "Current header:"
                : "Default header:"}
            </h4>
            <div className="bg-primary p-xs rounded-standard flex items-center justify-center shadow-xs">
              <img
                className="h-16 w-40 object-contain"
                src={
                  data?.user?.account?.logoFileLink
                    ? data?.user?.account?.logoFileLink
                    : "https://uploads-ssl.webflow.com/66203a368265774ffba79f60/66bc1f0c5af0e83d1d9c4607_scribenote-2024-svg.svg"
                }
              />
            </div>
          </div>
          {data?.user?.account?.logoFileLink && isEditing ? (
            <div className="absolute -bottom-2 self-center">
              <DSButton
                variant="danger"
                size="sm"
                icon={faTrash}
                onClick={async () => {
                  try {
                    await deleteHeaderImage();
                    await refetch();
                    setIsEditing(false);
                  } catch {
                    alert(
                      "error",
                      "An error has occurred. Please try again later or contact support.",
                    );
                  }
                }}
                dataTestId="delete-header-image-button"
              >
                Delete
              </DSButton>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-row items-center space-x-md">
      {!loading && renderLogo()}
      {isEditing && (
        <div className="flex-1">
          <AttachmentSelection
            isForNoteForm={false}
            control={control}
            acceptedFiles={"image/*"}
            shouldAcceptMultipleFiles={false}
          />
        </div>
      )}
    </div>
  );
}
